// extracted by mini-css-extract-plugin
module.exports = {"rcorners3":"SmallWindowBox_rcorners3__3cL4a","centerDiv":"SmallWindowBox_centerDiv__I2ipr","buttonWidth":"SmallWindowBox_buttonWidth__NqkQx"};